export const initialValues = {
  name: "",
  email: "",
  mobile_number: "",
  description: "",
  privacy_policy: "",
  terms_and_condition: "",
  address: "",
  logo: "",
  announcement: "",
  instagram_link: "",
  youtube_link: "",
  facebook_link: "",
  twitter_link: "",
  country_code: "",
  latitude: "",
  longitude: "",
};
